import styles from './Topbar.module.css'
import Logo  from '../../../assets/wiki-logo-mobile.svg?react'
import Bell  from '../../../assets/bell.svg?react'
import Burger  from '../../../assets/burger.svg?react'
import Donation  from '../../../assets/donation.svg?react'
import { useMemo } from 'react'
import WikiLoveMonuments from '../WikiLoveMonuments'
import { useTranslation } from 'react-i18next'
import { SlidesPresentazioneMobile } from '../Layout'
import ModalLanguage from '../../Desktop/ModalLanguage'
import ModalPaese from '../../Desktop/ModalPaese'
import { getActiveGeocontext, unicodeToChar } from '../../../utils'
import { useNavigate } from 'react-router-dom'
import { IS_WIKI_DOMAIN } from '../../../const'

export default function Topbar({
  show,
  setShow,
  infoWiki,
  setInfoWiki,
  presentazione,
  setPresentazione,
  modalPaese,
  setModalPaese,
  modalLang,
  setModalLang,
}: {
  show: boolean
  setShow: (value: boolean) => void
  infoWiki: boolean
  setInfoWiki: (value: boolean) => void
  presentazione: boolean
  setPresentazione: (value: boolean) => void
  modalPaese: boolean
  setModalPaese: (value: boolean) => void
  modalLang: boolean
  setModalLang: (value: boolean) => void
}) {
  const { t } = useTranslation()

  const activeGeocontext = getActiveGeocontext()

  const activeContest = useMemo(() => {
    if (!activeGeocontext) return null
    if (!activeGeocontext.next_contest) return null
    if (activeGeocontext.next_contest.active)
      return activeGeocontext.next_contest
    return null
  }, [activeGeocontext])

  const navigate = useNavigate()

  return (
    <>
      <div className={`${styles.TopBar} ${!IS_WIKI_DOMAIN ? styles.TopbarDebug : ''}`}>
        <div className="d-flex align-items-center">
          <div
            className="pointer me-3"
            style={{ fontSize: '1.5rem' }}
            onClick={() => {
              setModalPaese(true)
            }}
          >
            {activeGeocontext &&
              activeGeocontext.flag &&
              unicodeToChar(activeGeocontext.flag)}
          </div>
          <div
            className="pointer"
            onClick={() => {
              navigate('/')
            }}
          >
            <Logo />
          </div>
        </div>
        {activeContest && (
          <div className={styles.ContainerTitle}>
            <Bell /> <span className={styles.Title}>{t('GENERIC_CONTEST')} WLM</span>
          </div>
        )}
        <div className="d-flex align-items-center">
          {activeGeocontext?.enable_donations_text && activeGeocontext.donations_link && (
            <div className={'pointer'} onClick={() => window.open(activeGeocontext.donations_link, '_blank')}>
              <Donation className="me-3" />
            </div>
          )}
          <Burger
            className="pointer"
            onClick={() => {
              // blur body when menu is open backdrop-filter: blur(10px);

              setShow(!show)
            }}
          />
        </div>
      </div>
      <ModalLanguage modalLang={modalLang} setModalLang={setModalLang} />
      <ModalPaese modalPaese={modalPaese} setModalPaese={setModalPaese} />
      <WikiLoveMonuments
        infoWiki={infoWiki}
        setPresentazione={setPresentazione}
        setInfoWiki={(infoWiki: boolean) => setInfoWiki(infoWiki)}
        activeGeocontext={activeGeocontext}
      />
      {presentazione && (
        <SlidesPresentazioneMobile
          isFromPageWiki
          setPresentazione={setPresentazione}
        />
      )}
    </>
  )
}
